import { ArrowRight } from "lucide-react";
import skiresortLogo from "@/assets/skiresort-logo.webp";
import pizolLogo from "@/assets/pizol-logo.webp";
import heidilandLogo from "@/assets/heidiland-logo.webp";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const SKI_LINK =
  "https://en.heidiland.com/skipauschale-pizol.html?utm_campaign=skipauschale&utm_source=hotel_pizol&utm_medium=quelle&utm_content=lp_pizol&utm_term=de";

const SkiBanner = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  return (
    <a
      href={get("ski_link") || SKI_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full bg-[hsl(200,45%,25%)] py-4 md:py-6 hover:bg-[hsl(200,45%,28%)] transition-colors duration-300 cursor-pointer"
    >
      <div className="hotel-container">
        <div className="flex items-center justify-between gap-4 mb-3">
          <div className="flex items-center gap-4 md:gap-6">
            <div>
              <h2 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-[hsl(200,40%,75%)] leading-tight">
                {get("ski_title") || t.ski.title}
              </h2>
              <p className="font-body text-xs md:text-sm text-[hsl(200,20%,85%)] mt-0.5">
                {get("ski_subtitle") || t.ski.subtitle}
              </p>
            </div>
            <span className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 bg-white text-[hsl(200,45%,25%)] font-body text-[10px] uppercase tracking-[0.15em] font-semibold rounded-sm whitespace-nowrap">
              {get("ski_cta") || t.ski.cta}
              <ArrowRight className="w-3 h-3" />
            </span>
          </div>
          <div className="flex items-center gap-2 md:gap-4">
            <img src={skiresortLogo} alt="Skiresort.de Extraklasse 2025" loading="lazy" className="h-8 md:h-10 rounded-sm bg-white p-0.5" />
            <img src={pizolLogo} alt="Pizol Bad Ragaz – Wangs" loading="lazy" className="h-6 md:h-8" />
            <img src={heidilandLogo} alt="Heidiland Tourismus" loading="lazy" className="h-6 md:h-8 rounded-sm" />
          </div>
        </div>
      </div>
    </a>
  );
};

export default SkiBanner;
